import request from '../request';
import requestWithoutTimeout from '../requestWithoutTimeout';

const categoryService = {
  getAll: (params) =>
    request.get('dashboard/seller/categories/paginate', { params }),
  getAllList: (params) =>
    request.get('dashboard/seller/categories/all', { params }),
  getById: (id, params) =>
    request.get(`dashboard/seller/categories/${id}`, { params }),
  create: (params) =>
    request.post('dashboard/seller/categories', {}, { params }),
  update: (id, params) =>
    request.put(`dashboard/seller/categories/${id}`, {}, { params }),
  delete: (params) =>
    request.delete('dashboard/seller/categories/delete', { params }),
  search: (params) =>
    request.get('dashboard/seller/categories/search', { params }),
  selectPaginate: (params) =>
    request.get('dashboard/seller/categories/select-paginate', { params }),
  paginateSelect: (params) =>
    request.get('dashboard/seller/categories/select-paginate', { params }),
  setActive: (id) => request.post(`dashboard/seller/categories/${id}/active`),
  statusUpdate: (id, data) =>
    request.post(`dashboard/seller/categories/${id}/status`, data),
  updatePosition: (uuid, data) =>
    request.post(`dashboard/seller/category-input/${uuid}`, data),
  imageDelete: (uuid, data) =>
    request.post(`dashboard/seller/categories/${uuid}/image/delete`, data),
  dropAll: () => request.get('dashboard/seller/categories/drop/all'),
  restoreAll: (params) =>
    request.get('dashboard/seller/categories/restore/all', { params }),
  truncate: () => request.get('dashboard/seller/categories/truncate/db'),
  export: (params) =>
    requestWithoutTimeout.get('dashboard/seller/categories/export', { params }),
  import: (data) =>
    requestWithoutTimeout.post('dashboard/seller/categories/import', data),
};

export default categoryService;
